import Block from "../components/Block";
import Seo from "../components/Seo";

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy Policy"
        description="How Gapsmiths Consulting LLP collects, uses, and protects personal data."
      />
      <section className="wrap page-head">
        <h1>Privacy Policy</h1>
      </section>

      <Block marker="Privacy" bodyClassName="legal">
        <p className="stamp">Last updated 21 September 2026</p>

        <h2>1. Who we are</h2>
        <p>
          Gapsmiths Consulting LLP, based in Mumbai, Maharashtra, India, is responsible
          for the personal data collected through this website and through the products
          we operate.
        </p>
        <p>
          For anything relating to privacy, write to{" "}
          <a href="mailto:vivek@gapsmiths.com">vivek@gapsmiths.com</a>.
        </p>

        <h2>2. What we collect</h2>

        <h3>Information you give us</h3>
        <p>
          Your name, email address, phone number, organisation, and anything else you
          choose to include when you contact us, enquire about work, or use one of our products.
        </p>

        <h3>Billing information</h3>
        <p>Billing name, address, and GST details where we need to issue an invoice.</p>

        <h3>Information collected automatically</h3>
        <p>
          IP address, browser and device type, referring page, pages visited, and time
          spent, collected through standard web analytics.
        </p>

        <h2>3. Why we collect it</h2>
        <ul>
          <li>To respond to your enquiry or support request</li>
          <li>To deliver a product or service you've engaged us for</li>
          <li>To issue invoices and keep accounting records</li>
          <li>To meet our legal, tax, and accounting obligations in India</li>
          <li>To understand how the site and our products are used, and improve them</li>
        </ul>
        <p>
          We do not sell your personal data. We do not share it with third parties for
          their own advertising.
        </p>

        <h2>4. Who we share it with</h2>
        <p>
          We share personal data only with service providers who help us operate
          (hosting and infrastructure, email, invoicing and accounting tools, and
          analytics), and only to the extent needed for them to do that work.
        </p>
        <p>
          We may also disclose information where we're required to by law, court order,
          or a competent authority.
        </p>

        <h2>5. Cookies</h2>
        <p>
          We use cookies for basic site functionality and for analytics. You can
          disable cookies in your browser settings, though some parts of the site or
          our products may not work as intended if you do.
        </p>

        <h2>6. How long we keep it</h2>
        <p>
          We keep personal data for as long as it's needed for the purpose it was
          collected for, and for as long as Indian tax and accounting law requires.
          Transaction and invoice records are generally retained for eight years.
        </p>

        <h2>7. Your rights</h2>
        <p>You can ask us to:</p>
        <ul>
          <li>Tell you what personal data we hold about you</li>
          <li>Correct anything that's inaccurate or out of date</li>
          <li>Delete your data, where we're not legally required to keep it</li>
          <li>Stop sending you marketing communications</li>
        </ul>
        <p>
          Write to <a href="mailto:vivek@gapsmiths.com">vivek@gapsmiths.com</a> and
          we'll respond within 30 days. We may need to verify your identity before
          acting on a request.
        </p>

        <h2>8. Security</h2>
        <p>
          We use reasonable technical and organisational measures to protect personal
          data against loss, misuse, and unauthorised access. No system is perfectly
          secure, and we can't guarantee the absolute security of information sent over
          the internet.
        </p>

        <h2>9. Children</h2>
        <p>
          Our website is not directed at anyone under 18, and we don't knowingly
          collect personal data from children through it. If you believe we have, write
          to us and we'll delete it.
        </p>

        <h2>10. Changes to this policy</h2>
        <p>
          We may update this policy from time to time. The date at the top of this page
          shows when it was last revised.
        </p>

        <h2>11. Contact</h2>
        <p>
          Gapsmiths Consulting LLP<br />
          Mumbai, Maharashtra<br />
          <a href="mailto:vivek@gapsmiths.com">vivek@gapsmiths.com</a> · +91 93230 29857
        </p>
      </Block>
    </>
  );
}
